module.exports = __webpack_public_path__ + "static/media/accordian_down_arrow.a29bca38.svg";